import { Component, inject, signal } from '@angular/core';
import { AbstractControl, NonNullableFormBuilder, ReactiveFormsModule, ValidationErrors, Validators } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { CONTACT_EMAIL, DEMO_REQUEST } from '../../content/home.content';
import { DemoRequestService } from './demo-request.service';

type Status = 'idle' | 'sending' | 'sent' | 'error';

/** Telefone opcional: se preenchido, aceita dígitos, espaços, (), - e +, com 10 a 13 dígitos. */
function optionalPhone(control: AbstractControl<string>): ValidationErrors | null {
  const value = control.value.trim();
  if (!value) {
    return null;
  }
  const digits = value.replace(/\D/g, '').length;
  return /^[\d\s()+-]+$/.test(value) && digits >= 10 && digits <= 13 ? null : { phone: true };
}

@Component({
  selector: 'app-demo-request',
  imports: [ReactiveFormsModule, RouterLink],
  templateUrl: './demo-request.component.html'
})
export class DemoRequestComponent {
  private readonly demoRequest = inject(DemoRequestService);

  readonly content = DEMO_REQUEST;
  readonly contactEmail = CONTACT_EMAIL;
  readonly status = signal<Status>('idle');

  readonly form = inject(NonNullableFormBuilder).group({
    name: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(120)]],
    email: ['', [Validators.required, Validators.email, Validators.maxLength(254)]],
    phone: ['', [optionalPhone, Validators.maxLength(25)]],
    institution: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(160)]],
    role: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(120)]],
    consent: [false, Validators.requiredTrue],
    website: ['']
  });

  showError(field: keyof typeof this.form.controls): boolean {
    const control = this.form.controls[field];
    return control.invalid && control.touched;
  }

  async submit(): Promise<void> {
    if (this.status() === 'sending') {
      return;
    }
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.status.set('sending');
    try {
      await this.demoRequest.submit(this.form.getRawValue());
      this.form.reset();
      this.status.set('sent');
    } catch {
      this.status.set('error');
    }
  }
}
